// プール内の招待
$(() => {
    if (document.getElementById('js-poolInvitation') != null) {
        $('.js-invitation-block-show, .js-invitation-block-hide').on('click',function(){
            $('.js-invitation-block').slideToggle('fast');
        })
        $('.js-invitation-managed-block-show, .js-invitation-managed-block-hide').on('click',function(){
            $('.js-invitation-managed-block').slideToggle('fast');
        })

    }
});